import React               from "react";

import { LoaderVariants, 
         Overlay, 
         Spinner, 
         loader_variants } from "src/components/common/loader/ui";



export type Props = {
  isLoading: boolean;
  variant: LoaderVariants
};
export const Loader: React.FC<Props> = ({
  isLoading,
  variant = 'loader_main'
}) => {
  const lookAndFeel = loader_variants.get(variant)!;

  if (!isLoading) return null;

  return (
    <Overlay lookAndFeel = { lookAndFeel }>
      <Spinner lookAndFeel = { lookAndFeel }/>
    </Overlay>
  );
};
